const RULE = {
  SNAT: 'SNAT',
};

const RULE_TITLE = {
  [RULE.SNAT]: 'SNAT',
};

const PROTOCOL = {
  TCP: 'TCP',
  UDP: 'UDP',
  ICMP: 'ICMP',
  ALL: 'ALL',
};

export const NAT_GATEWAY = {
  RULE,
  RULE_TITLE,
  PROTOCOL,
};

